import "../styles/hero.css";
import BackgroundVideo from "../components/BackgroundVideo";
import HeroImage from "../assets/logo.png";

const Home = () => {
  return (
    <section id="hero" className="d-flex justify-content-center">
      <BackgroundVideo />

      <div className="hero-content">
        <h1>CARPE MINISTRIES</h1>

        <img
          src={HeroImage}
          alt="CARPE Ministries"
          className="hero-img"
        />

        <h2>LIFE NOW</h2>
      </div>
    </section>
  );
};

export default Home;